module.exports = __webpack_public_path__ + "img/Christmasforgood.0024c673.png";